import { SxProps, Theme } from '@mui/material/styles';
import { inContextAddButtonSx } from 'components/general/buttonActionStyles';
import { Color } from 'shared/utils/colors';

export const ANSWER_CARD_HEADER_SX: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  mb: 1.5,
};

export const ANSWER_FIELD_ROW_SX: SxProps<Theme> = {
  display: 'flex',
  gap: 2,
  mb: 1.5,
  '& > *': {
    flex: 1,
  },
};

/** Outlined secondary add action — content width inside vertical stacks. */
export const ADD_ANSWER_BUTTON_SX: SxProps<Theme> = {
  ...inContextAddButtonSx,
  alignSelf: 'flex-start',
};

export const TABS_CONTAINER_SX: SxProps<Theme> = {
  mx: -2,
  mt: -2,
  px: 2,
  borderBottom: `1px solid ${Color.border}`,
  mb: 2,
  '& .MuiTabs-root': {
    minHeight: 48,
  },
};

export const TAB_SX: SxProps<Theme> = {
  textTransform: 'none',
  fontWeight: 500,
  minHeight: 48,
  py: 1.5,
};

export function getChecklistItemTabSx(hasError: boolean): SxProps<Theme> {
  if (!hasError) {
    return TAB_SX;
  }

  return {
    ...TAB_SX,
    color: 'error.main',
    '&.Mui-selected': {
      color: 'error.main',
    },
  };
}

export const DELETE_ANSWER_BUTTON_SX: SxProps<Theme> = {
  color: Color.textIcon,
  '&:hover': {
    color: Color.errorRed,
    bgcolor: Color.errorRedBg08,
  },
};

export const OPTION_ROW_SX: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

/** The option label editor and its error: they take the row's free width. */
export const OPTION_LABEL_FIELD_SX: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
};

export const OPTION_DELETE_SLOT_SX: SxProps<Theme> = {
  width: 32,
  height: 32,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const OPTION_LIST_SX: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  mb: 2,
};

export const OPTION_SELECTION_FIELDS_ROW_SX: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  mb: 2,
  '& > .MuiFormControl-root': {
    flex: 1,
    minWidth: 0,
  },
  '& > .MuiFormControlLabel-root': {
    flexShrink: 0,
    m: 0,
  },
};
